import { type ApiResponse } from '@webapp/core/interfaces/api/ApiResponse'
import { type Enum } from '@webapp/infrastructure/types/Enum'
import { type GlobalSearchResultTypeEnum } from '../../value-objects/enums'
import { type GlobalSearchResultApiModel } from '../api-models/GlobalSearchResultApiModel'

export const GlobalSearchWarningCodes = {
  TRUNCATED_RESULTS: 'TRUNCATED_RESULTS',
  UNSUPPORTED_QUERY: 'UNSUPPORTED_QUERY',
} as const

type GlobalSearchWarningCode = Enum<typeof GlobalSearchWarningCodes>

type GlobalSearchWarning = {
  code: GlobalSearchWarningCode
  message?: { title: string; description: string }
}

export type GlobalSearchApiMetadata = {
  total: number
  counts: { type: GlobalSearchResultTypeEnum; count: number }[]
  warnings?: GlobalSearchWarning[]
}

export type GlobalSearchResponse = ApiResponse<
  GlobalSearchResultApiModel[],
  GlobalSearchApiMetadata
>
